export const OFFER_PARTNER_KNOCKOUT_CRITERIA_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerKnockoutCriteriaInvalidated";
export const OFFER_PARTNER_KNOCKOUT_CRITERIA_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.EvaluateKnockoutCriteriaExecuted";
export const OFFER_PARTNER_KNOCKOUT_CRITERIA_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerKnockoutCriteriaUpdated";
